import { RootState } from "@/store/store";
import { gridResourceDataSelector } from "@/store/resources-grid/selectors/resource-data/gridResourceDataSelector";

export const gridResourcesEmsSelector = (
  state: RootState,
  masterGridId: string,
) => {
  const resourcesData = gridResourceDataSelector(state, masterGridId);

  return resourcesData && "estimated_monthly_waste" in resourcesData
    ? resourcesData?.estimated_monthly_waste
    : 0;
};
